import { Typography, Box, Container, Stack, useMediaQuery } from "@mui/material";
import { ContactTitle } from "../../styles/contactme/index";
import Fade from "react-reveal/Fade";
import { useTheme } from "@mui/system";
import Paper from "@mui/material/Paper";

export default function Dashboards() {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      id="dashboards"
      display="flex"
      flexDirection="row"
      width="100%"
      height="100%"
      justifyContent="center"
      alignItems="center"
      textAlign="center"
      paddingTop="60px"
    >
      <Stack id="dashboard_reports" spacing={2}>
        <Box>
          {matches ? (
            <Box display="flex" flexDirection="column" marginBottom="150px">
              <Fade>
                <ContactTitle marginBottom="20px">Dashboards</ContactTitle>
              </Fade>
              <Fade cascade>
                <Container>
                  <Paper
                    elevation={3}
                    sx={{
                      pt: 1,
                      pb: 3,
                      pl: 6,
                      pr: 6,
                      bgcolor: "background.default",
                    }}
                  >
                    <iframe title="Sales Analysis" 
                      width="300" 
                      height="250" 
                      src="https://app.powerbi.com/view?r=eyJrIjoiMDcwNDQxZTAtYTgyNC00NzljLWJlZGQtNmExMDg4M2ZlZGU0IiwidCI6IjJhNzkxYWEzLTEwMzktNGZhZS1hYTljLTQwMDkzYWVlNDU4ZSJ9" 
                      frameborder="0" 
                      allowFullScreen="true">
                     </iframe>
                    <p>_______________________________</p>
                    <iframe
                      title="HR Analytics"
                      width="300"
                      height="250"
                      src="https://app.powerbi.com/view?r=eyJrIjoiNzIzOTI3ZDctODc4Ni00YzU3LWJlNmYtNmU0ODY4NjBjMDY3IiwidCI6IjJhNzkxYWEzLTEwMzktNGZhZS1hYTljLTQwMDkzYWVlNDU4ZSJ9&pageName=5b8da414e788dd928b6b"
                      frameborder="0"
                      allowFullScreen="true"
                    ></iframe>
                    <p>_______________________________</p>
                    <iframe
                      title="Bike Shop"
                      width="300"
                      height="250"
                      src="https://app.powerbi.com/view?r=eyJrIjoiOTY2ZmMxODYtMjRiYS00MWY4LWFkMzYtMmYwNDI3YzU3MzhiIiwidCI6IjJhNzkxYWEzLTEwMzktNGZhZS1hYTljLTQwMDkzYWVlNDU4ZSJ9"
                      frameborder="0"
                      allowFullScreen="true"
                    ></iframe>
                  </Paper>
                </Container>
              </Fade>
            </Box>
          ) : (
            <Box display="flex" flexDirection="column" marginBottom="180px">
              <Fade>
                <ContactTitle marginBottom="20px">
                  Dashboards & Reports
                </ContactTitle>
              </Fade>
              <Fade cascade>
                <Container>
                  <Paper
                    elevation={3}
                    sx={{
                      pt: 2,
                      pb: 2,
                      pl: 2,
                      pr: 2,
                      bgcolor: "background.default",
                    }}
                  >
                    <Typography
                      fontWeight="Bold"
                      fontSize={16}
                      paddingTop={1.5}
                    >
                      SALES ANALYSIS DASHBOARD
                    </Typography>
                    <Typography
                      fontSize={14}
                      paddingTop={1.5}
                      marginLeft={9}
                      marginRight={8}
                      marginBottom={2}
                      align="justify"
                    >
                      Implementing centralized sales dashboards ensures that all stakeholders whether they are individual sellers, sales managers, or senior executives are accessing and relying on the same consistent, up-to-date data. This alignment fosters a shared understanding of performance metrics and encourages collaboration across teams. When everyone speaks the same data-driven language, it becomes easier to coordinate efforts, set unified goals, and measure progress against common Key Performance Indicators.
                    </Typography>
                    <iframe 
                      title="Sales Analysis - Production" 
                      width="1024" 
                      height="612" 
                      src="https://app.powerbi.com/view?r=eyJrIjoiMDcwNDQxZTAtYTgyNC00NzljLWJlZGQtNmExMDg4M2ZlZGU0IiwidCI6IjJhNzkxYWEzLTEwMzktNGZhZS1hYTljLTQwMDkzYWVlNDU4ZSJ9" 
                      frameborder="0" 
                      allowFullScreen="true"
                    ></iframe>
                    <p>_______________________________</p>
                    <Typography
                      fontWeight="Bold"
                      fontSize={16}
                      paddingTop={1.5}
                    >
                      HUMAN RESOURCES REPORT
                    </Typography>
                    <Typography
                      fontSize={14}
                      paddingTop={1.5}
                      marginLeft={9}
                      marginRight={8}
                      marginBottom={2}
                      align="justify"
                    >
                      Human Resource reports are essential for any organization that values strategic planning, operational efficiency, and employee well-being. They go beyond basic metrics to inform decisions about hiring, retention, performance, diversity, compensation and employee engagement. HR reports become predictive tools that link people metrics to outcomes like productivity, customer satisfaction, and profitability. Ultimately, they empower leaders to make data-driven decisions, foster a fair and inclusive workplace, and align human capital strategy with long-term business goals.
                    </Typography>
                    <iframe
                      title="HR Analytics"
                      width="1024"
                      height="612"
                      src="https://app.powerbi.com/view?r=eyJrIjoiNzIzOTI3ZDctODc4Ni00YzU3LWJlNmYtNmU0ODY4NjBjMDY3IiwidCI6IjJhNzkxYWEzLTEwMzktNGZhZS1hYTljLTQwMDkzYWVlNDU4ZSJ9&pageName=5b8da414e788dd928b6b"
                      frameborder="0"
                      allowFullScreen="true"
                    ></iframe>
                    <p>_______________________________</p>
                    <Typography
                      fontWeight="Bold"
                      fontSize={16}
                      paddingTop={1.5}
                    >
                      CUSTOMER SATISFACTION SURVEY
                    </Typography>
                    <Typography
                      fontSize={14}
                      paddingTop={1.5}
                      marginLeft={9}
                      marginRight={8}
                      marginBottom={2}
                      align="justify"
                    >
                      Customer satisfaction surveys are essential tools for businesses to gauge how well they are meeting customer expectations and delivering value. These surveys provide direct feedback from customers, revealing insights into their experiences, preferences, and pain points. By analyzing this data, companies can identify areas for improvement, enhance product or service quality, and tailor their offerings to better meet customer needs. Moreover, satisfied customers are more likely to become repeat buyers and brand advocates, while dissatisfied ones may turn to competitors. Regularly conducting satisfaction surveys not only fosters customer loyalty but also helps businesses stay competitive and responsive in a dynamic market.
                    </Typography>
                    <img
                      src="/images/projects/Mobile Version.png"
                      width="375"
                      height="712"
                      alt="Power BI Dashboard"
                    />
                    <p>_______________________________</p>
                    <a href="https://app.powerbi.com/view?r=eyJrIjoiOGNmMWEwN2YtNTUwNi00NDBhLWExZTMtOWQ5MjdkOWJmNWU4IiwidCI6IjJhNzkxYWEzLTEwMzktNGZhZS1hYTljLTQwMDkzYWVlNDU4ZSJ9">
                      <img
                        src="/images/projects/Survey.png"
                        width="780"
                        height="900"
                        alt="Survey Form"
                      />
                    </a>
                    <p>_______________________________</p>
                    <Typography
                      fontWeight="Bold"
                      fontSize={16}
                      paddingTop={1.5}
                    >
                      ANNUAL SALES REPORT
                    </Typography>
                    <Typography
                      fontSize={14}
                      paddingTop={1.5}
                      marginLeft={9}
                      marginRight={8}
                      marginBottom={2}
                      align="justify"
                    >
                      An annual sales report is a vital tool for evaluating a company’s performance over the course of a year. It provides a comprehensive overview of revenue generated, sales trends, customer behavior, and market dynamics, enabling businesses to assess their financial health and strategic effectiveness. By analyzing this data, companies can identify strengths and weaknesses in their sales strategies, set realistic goals, and make informed decisions for future growth.
                    </Typography>

                    <iframe
                      title="Report Builder"
                      // class="pdf"
                      src="/images/projects/PowerBiReportBuilder.pdf"
                      width="800"
                      height="500"
                    ></iframe>
                    {/* <img
                      src="/images/courses/SharePoint_site.png"
                      width="1024"
                      height="750"
                      alt="Power BI Dashboard"
                    /> */}
                  </Paper>
                </Container>
              </Fade>
            </Box>
          )}
        </Box>
      </Stack>
    </Box>
  );
}
